import { CatalogProductsSchema, MeterSchema } from '@vy/types';
import { oz, ValueOf } from '@vy/utils';
import { CreditTypeSchema } from '@vy/api-definition';

export const PRODUCT_TYPE = Object.freeze({
  METERED: 'Metered',
  SERVICE: 'Service',
  CREDIT: 'Credit',
} as const);

export type ProductType = ValueOf<typeof PRODUCT_TYPE>;

const CatalogProductRow = CatalogProductsSchema.extend({
  type: oz.literal(PRODUCT_TYPE.SERVICE),
});

export type CatalogProductsRow = oz.infer<typeof CatalogProductRow>;

const MeterProductRow = MeterSchema.extend({
  type: oz.literal(PRODUCT_TYPE.METERED),
});

export type MeterProductRow = oz.infer<typeof MeterProductRow>;

const CreditTypeRowSchema = CreditTypeSchema.extend({
  type: oz.literal(PRODUCT_TYPE.CREDIT),
  isDeletable: oz.boolean(),
});

export type CreditTypeRow = oz.infer<typeof CreditTypeRowSchema>;

export type UnifiedProductRow = MeterProductRow | CatalogProductsRow | CreditTypeRow;
